import React, {Component} from 'react'
import ListItem from './ListItem'
import List from './List'
import MobileMenu from './MobileMenu'
import back from './img/backward.png'
import PropTypes from 'prop-types'

class MobileList extends Component {

  constructor(props) {
    super(props)
    this.state = {
      activeItemSecondLevelMenu: 0,
      activeItemThirdLevelMenu: 0,
      thirdLevelMenuVisibility: false
    }
  }

  handleItemClick = (listLevelId, e) => {
    const key = 'activeItem' + listLevelId
    const activeItemFirstLevelMenu = this.props.activeItem.toString()

    this.setState({[key]: e.target.id})
    if (key === 'activeItemSecondLevelMenu') {
      if (this.props.list && this.props.list.find(obj => obj.id.toString() === activeItemFirstLevelMenu).items.find(obj => obj.id.toString() === e.target.id).items.length) {
        this.setState({thirdLevelMenuVisibility: true})
      }
    }
  }

  hideThirdLevelMenu = () => {
    this.setState({thirdLevelMenuVisibility: false})
  }

  render() {
    const activeItemFirstLevelMenu = this.props.activeItem.toString()
    const labels = require(`../../trans/${this.props.language}`)
    return this.props.list.map((listItem, index) => {
      return (
        <div className={'p-0'} key={index}>
          <div className={`separate-links mobile-link-${listItem.id}`}>
          <ListItem activeItem={activeItemFirstLevelMenu === listItem.id.toString()} listItem={listItem}
                    level={'first-link'} handleItemClick={(e) => this.handleItemClick('FirstLevelMenu', e)}/>
          </div>
          {activeItemFirstLevelMenu === listItem.id.toString() &&
          <List list={listItem.items} handleItemClick={(e) => this.handleItemClick('SecondLevelMenu', e)}
                activeItem={this.state.activeItemSecondLevelMenu} level={'mobile-second-level'}/>
          }
          {this.state.activeItemSecondLevelMenu !== 0 && activeItemFirstLevelMenu === listItem.id.toString() && this.state.thirdLevelMenuVisibility &&
          <MobileMenu show={this.state.thirdLevelMenuVisibility}>
            <div className={'text-left m-4'}>
              <div className="yettel-link" onClick={this.hideThirdLevelMenu}>
                <img width="19" src={back} alt="back"/>
                <span className="yettel-link pl-2 text-16">{labels.back}</span>
              </div>
            </div>
            <List
              list={listItem.items.find(obj => obj.id.toString() === this.state.activeItemSecondLevelMenu.toString()).items}
              handleItemClick={(e) => this.handleItemClick('ThirdLevelMenu', e)}
              activeItem={this.state.activeItemThirdLevelMenu} level={'mobile-third-level'}/>
          </MobileMenu>
          }
        </div>
      )
    })
  }
}

MobileList.propTypes = {
  language: PropTypes.string.isRequired,
  level: PropTypes.string.isRequired,
  list: PropTypes.array.isRequired
}

export default MobileList
